import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import psychologicalOrderTypeValidator from 'forms/sections/psychological/shared/orderTypeValidator';
import { PsychologicalConsultationsModel } from './types';

const psychologicalConsultationsValidator: ValidateJSModel<PsychologicalConsultationsModel> = {
  Consulted: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.Consulted && attributes?.Consulted.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: psychologicalOrderTypeValidator, requireDisposition: true },
      };
    }
    return {};
  },

  Comments: {},

  SummaryComments: {},
};

export default psychologicalConsultationsValidator;
